import { PageRef } from 'providers/page-ref';

export type DbSnapshotsPageParams = {};

export const IDbSnapshotsPage: PageRef<DbSnapshotsPageParams, void> = {
  pageName: 'DbSnapshotsPage',
} as PageRef<DbSnapshotsPageParams, void>;
